<template>
    <ChannelBackendEntityAssociationCmp 
        :association-service="associationService"
        :entity-plural="entityPlural" 
        :one-to-one="false"
        :allow-export-enabled="false" />
</template>

<script>
import ChannelBackendEntityAssociationCmp from '@/utils/components/ChannelBackendEntityAssociationCmp'
import paymentService from '@/payment/services/PaymentService'

export default {
    name: 'ChannelPaymentListAssociationView',
    components: {
        ChannelBackendEntityAssociationCmp,
    },
    data() {
        return {
            associationService: paymentService,
            entityPlural: "formas de pagamento",
        }
    },
}
</script>

